import React from 'react';
import { Card, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

// A simple persistent error card with a close button.
// Props:
// - visible: boolean
// - title: string
// - message: string or node
// - onClose: function
const PersistentErrorCard = ({ visible = false, title = 'Error', message = '', onClose = () => {} }) => {
  if (!visible) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <Card
        size="small"
        title={title}
        extra={(
          <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
        )}
        style={{ borderColor: '#ff4d4f', background: '#fff1f0' }}
      >
        <div style={{ color: '#a8071a' }}>{message}</div>
      </Card>
    </div>
  );
};

export default PersistentErrorCard;
